import { render } from "./StatisticView.vue?vue&type=template&id=4325a218&scoped=true"
import script from "./StatisticView.vue?vue&type=script&lang=js"
export * from "./StatisticView.vue?vue&type=script&lang=js"

import "./StatisticView.vue?vue&type=style&index=0&id=4325a218&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4325a218"]])

export default __exports__